export function ContactUs({ contact }) {

  const currentLanguage = localStorage.getItem('lang') || 'en';

    const noMapText = {
    am: "Քարտեզի հղում չկա",
    ru: "Ссылка на карту отсутствует",
    en: "Map link not available",
  };
  
  return (
    <section id="contact">
      <div className="container">
        <h2 className="heading">
          <span>
            <p>{contact.heading}</p>
          </span>
          <div className="line"></div>
        </h2>
        <div className="box_map">
         {contact.map_url ? (

            <iframe src={`https://www.google.com/maps${contact.map_url}`} title="Map" />
          ) :(
            <h2>{noMapText[currentLanguage]}</h2>
          )
        }
        </div>
      </div>
    </section>
  );
}

{/* <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3049.091067336347!2d44.50292667551477!3d40.16252607107256!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x406abd9428540b71%3A0x5db3f83c0475bf80!2sShopping%20City!5e0!3m2!1sru!2sam!4v1767865006753!5m2!1sru!2sam" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> */}